import { render, staticRenderFns } from "./InstagramLogo.vue?vue&type=template&id=867d2426&scoped=true&"
import script from "./InstagramLogo.vue?vue&type=script&lang=js&"
export * from "./InstagramLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867d2426",
  null
  
)

export default component.exports